// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-form {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 0 15%;
  touch-action: manipulation;
  -webkit-touch-callout: none;
}
@media screen and (max-width: 768px) {
  .login-form {
    padding: 0 8%;
  }
}
@media screen and (max-width: 480px) {
  .login-form {
    padding: 0 5%;
  }
}
.login-form__help {
  width: 100%;
  display: flex;
  flex-direction: row;
  color: #8F8F8F;
  font-size: 1rem;
  justify-content: center;
}
@media screen and (max-width: 480px) {
  .login-form__help {
    font-size: 0.875rem;
  }
}
.login-form__click {
  margin: 0 0.25rem;
  color: #7F56DA;
  font-size: 1rem;
  cursor: pointer;
}
@media screen and (max-width: 480px) {
  .login-form__click {
    font-size: 0.875rem;
  }
}
.login-form__logo {
  width: 80%;
  margin: 25% 0 20% 0;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}
@media screen and (max-width: 768px) {
  .login-form__logo {
    width: 250px;
    margin: 15% 0 10% 0;
  }
}
@media screen and (max-width: 480px) {
  .login-form__logo {
    width: 200px;
    margin: 10% 0 8% 0;
  }
}
.login-form__header {
  width: 100%;
  margin-bottom: 10%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media screen and (max-width: 768px) {
  .login-form__header {
    margin-bottom: 8%;
  }
}
.login-form__titles {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  text-align: center;
}
.login-form__title {
  color: #000;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: bold;
}
@media screen and (max-width: 480px) {
  .login-form__title {
    font-size: 1.25rem;
  }
}
.login-form__subtitle {
  color: #8F8F8F;
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.login-form__inputs {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 1.5rem;
}
@media screen and (max-width: 768px) {
  .login-form__inputs {
    gap: 1.25rem;
  }
}
.login-form__inputs__label {
  font-weight: bold;
  font-size: 0.75rem;
}
@media screen and (max-width: 480px) {
  .login-form__inputs__label {
    font-size: 1rem;
    margin-bottom: 0.25rem;
  }
}
.login-form__inputs__input-combo {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.5rem;
  width: 100%;
}
@media screen and (max-width: 480px) {
  .login-form__inputs__input-combo {
    gap: 1rem;
    margin-bottom: 0.5rem;
  }
}
.login-form__inputs__help {
  width: 100%;
  display: flex;
  flex-direction: row;
  color: #8F8F8F;
  font-size: 0.75rem;
  justify-content: flex-end;
}
@media screen and (max-width: 480px) {
  .login-form__inputs__help {
    font-size: 1rem;
  }
}
.login-form__inputs__click {
  margin: 0 0.25rem;
  color: #7F56DA;
  font-size: 0.75rem;
  cursor: pointer;
}
@media screen and (max-width: 480px) {
  .login-form__inputs__click {
    font-size: 1rem;
  }
}
.login-form__inputs__button {
  width: 100%;
  margin-top: 10%;
  background-color: #000;
  border-color: transparent;
  border-radius: 4px;
  padding: 3% 0;
  font-size: 0.75rem;
  transition: none !important;
}
@media screen and (max-width: 768px) {
  .login-form__inputs__button {
    margin-top: 8%;
    padding: 4% 0;
  }
}
@media screen and (max-width: 480px) {
  .login-form__inputs__button {
    height: 4rem;
    font-size: 1.125rem;
    margin-top: 1.5rem;
  }
}
.login-form__inputs__button .p-button-label,
.login-form__inputs__button .p-button-icon {
  transition: none !important;
}
.login-form__inputs__text-input {
  width: 100%;
}
.login-form__inputs__text-input::placeholder {
  font-size: 0.75rem !important;
}
@media screen and (max-width: 480px) {
  .login-form__inputs__text-input {
    height: 3.5rem !important;
    font-size: 1.125rem !important;
    touch-action: manipulation;
    -webkit-touch-callout: none;
  }
  .login-form__inputs__text-input input {
    font-size: 16px !important;
  }
  .login-form__inputs__text-input::placeholder {
    font-size: 1rem !important;
  }
  .login-form__inputs__text-input .p-inputtext {
    padding: 1rem 0.75rem;
  }
}
.login-form__error {
  color: #ff0000;
  font-size: 0.875rem;
  text-align: center;
  width: 100%;
  display: block;
}
@media screen and (max-width: 480px) {
  .login-form__error {
    font-size: 1rem;
    margin: 0.5rem 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/authentication/components/login-form/login-form.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,2BAAA;AACJ;AACI;EATJ;IAUQ,aAAA;EAEN;AACF;AAAI;EAbJ;IAcQ,aAAA;EAGN;AACF;AADI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,uBAAA;AAGR;AADQ;EARJ;IASQ,mBAAA;EAIV;AACF;AADI;EACI,iBAAA;EACA,cAAA;EACA,eAAA;EACA,eAAA;AAGR;AADQ;EANJ;IAOQ,mBAAA;EAIV;AACF;AADI;EACI,UAAA;EACA,mBAAA;EACA,0CAAA;EACA,4BAAA;EACA,wCAAA;AAGR;AADQ;EAPJ;IAQQ,YAAA;IACA,mBAAA;EAIV;AACF;AAFQ;EAZJ;IAaQ,YAAA;IACA,kBAAA;EAKV;AACF;AAFI;EACI,WAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAIR;AAFQ;EAPJ;IAQQ,iBAAA;EAKV;AACF;AAFI;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AAIR;AADI;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;AAGR;AADQ;EANJ;IAOQ,kBAAA;EAIV;AACF;AADI;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAGR;AAAI;EACI,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,WAAA;AAER;AAAQ;EANJ;IAOQ,YAAA;EAGV;AACF;AADQ;EACI,iBAAA;EACA,kBAAA;AAGZ;AADY;EAJJ;IAKQ,eAAA;IACA,sBAAA;EAId;AACF;AADQ;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;AAGZ;AADY;EAPJ;IAQQ,SAAA;IACA,qBAAA;EAId;AACF;AADQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,yBAAA;AAGZ;AADY;EARJ;IASQ,eAAA;EAId;AACF;AADQ;EACI,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;AAGZ;AADY;EANJ;IAOQ,eAAA;EAId;AACF;AADQ;EACI,WAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,kBAAA;EACA,2BAAA;AAGZ;AADY;EAVJ;IAWQ,cAAA;IACA,aAAA;EAId;AACF;AAFY;EAfJ;IAgBQ,YAAA;IACA,mBAAA;IACA,kBAAA;EAKd;AACF;AAHY;;EAEI,2BAAA;AAKhB;AADQ;EACI,WAAA;AAGZ;AAFY;EACI,6BAAA;AAIhB;AADY;EANJ;IAOQ,yBAAA;IACA,8BAAA;IACA,0BAAA;IACA,2BAAA;EAId;EAFc;IACI,0BAAA;EAIlB;EADc;IACI,0BAAA;EAGlB;EAAc;IACI,qBAAA;EAElB;AACF;AAGI;EACI,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;AADR;AAGQ;EAPJ;IAQQ,eAAA;IACA,gBAAA;EAAV;AACF","sourcesContent":[".login-form {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    padding: 0 15%;\n    touch-action: manipulation;\n    -webkit-touch-callout: none;\n\n    @media screen and (max-width: 768px) {\n        padding: 0 8%;\n    }\n\n    @media screen and (max-width: 480px) {\n        padding: 0 5%;\n    }\n\n    &__help {\n        width: 100%;\n        display: flex;\n        flex-direction: row;\n        color: #8F8F8F;\n        font-size: 1rem;\n        justify-content: center;\n\n        @media screen and (max-width: 480px) {\n            font-size: 0.875rem;\n        }\n    }\n\n    &__click {\n        margin: 0 0.25rem;\n        color: #7F56DA;\n        font-size: 1rem;\n        cursor: pointer;\n\n        @media screen and (max-width: 480px) {\n            font-size: 0.875rem;\n        }\n    }\n\n    &__logo {\n        width: 80%;\n        margin: 25% 0 20% 0;\n        image-rendering: -webkit-optimize-contrast;\n        image-rendering: crisp-edges;\n        -ms-interpolation-mode: nearest-neighbor;\n\n        @media screen and (max-width: 768px) {\n            width: 250px;\n            margin: 15% 0 10% 0;\n        }\n\n        @media screen and (max-width: 480px) {\n            width: 200px;\n            margin: 10% 0 8% 0;\n        }\n    }\n\n    &__header {\n        width: 100%;\n        margin-bottom: 10%;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n\n        @media screen and (max-width: 768px) {\n            margin-bottom: 8%;\n        }\n    }\n\n    &__titles {\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        gap: 1rem;\n        text-align: center;\n    }\n\n    &__title {\n        color: #000;\n        font-size: 1.5rem;\n        font-style: normal;\n        font-weight: bold;\n\n        @media screen and (max-width: 480px) {\n            font-size: 1.25rem;\n        }\n    }\n\n    &__subtitle {\n        color: #8F8F8F;\n        font-size: 0.75rem;\n        font-style: normal;\n        font-weight: 500;\n        line-height: normal;\n    }\n\n    &__inputs {\n        display: flex;\n        flex-direction: column;\n        align-items: flex-end;\n        gap: 1.5rem;\n\n        @media screen and (max-width: 768px) {\n            gap: 1.25rem;\n        }\n\n        &__label {\n            font-weight: bold;\n            font-size: 0.75rem;\n\n            @media screen and (max-width: 480px) {\n                font-size: 1rem;\n                margin-bottom: 0.25rem;\n            }\n        }\n\n        &__input-combo {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-start;\n            gap: 0.5rem;\n            width: 100%;\n\n            @media screen and (max-width: 480px) {\n                gap: 1rem;\n                margin-bottom: 0.5rem;\n            }\n        }\n\n        &__help {\n            width: 100%;\n            display: flex;\n            flex-direction: row;\n            color: #8F8F8F;\n            font-size: 0.75rem;\n            justify-content: flex-end;\n\n            @media screen and (max-width: 480px) {\n                font-size: 1rem;\n            }\n        }\n\n        &__click {\n            margin: 0 0.25rem;\n            color: #7F56DA;\n            font-size: 0.75rem;\n            cursor: pointer;\n\n            @media screen and (max-width: 480px) {\n                font-size: 1rem;\n            }\n        }\n\n        &__button {\n            width: 100%;\n            margin-top: 10%;\n            background-color: #000;\n            border-color: transparent;\n            border-radius: 4px;\n            padding: 3% 0;\n            font-size: 0.75rem;\n            transition: none !important;\n\n            @media screen and (max-width: 768px) {\n                margin-top: 8%;\n                padding: 4% 0;\n            }\n\n            @media screen and (max-width: 480px) {\n                height: 4rem;\n                font-size: 1.125rem;\n                margin-top: 1.5rem;\n            }\n\n            .p-button-label,\n            .p-button-icon {\n                transition: none !important;\n            }\n        }\n\n        &__text-input {\n            width: 100%;\n            &::placeholder {\n                font-size: 0.75rem !important;\n            }\n\n            @media screen and (max-width: 480px) {\n                height: 3.5rem !important;\n                font-size: 1.125rem !important;\n                touch-action: manipulation;\n                -webkit-touch-callout: none;\n                \n                input {\n                    font-size: 16px !important;\n                }\n\n                &::placeholder {\n                    font-size: 1rem !important;\n                }\n\n                .p-inputtext {\n                    padding: 1rem 0.75rem;\n                }\n            }\n        }\n    }\n\n    &__error {\n        color: #ff0000;\n        font-size: 0.875rem;\n        text-align: center;\n        width: 100%;\n        display: block;\n\n        @media screen and (max-width: 480px) {\n            font-size: 1rem;\n            margin: 0.5rem 0;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
